module.exports = {"modalTitle":"Kies ien of meardere regio's","title":"Abonneminten","intro":"Foar hokker regio’s wolst de abonneminten sjen?","selectRegions":"Kies dyn regio(‘s)","changeRegionSelection":"Wizigje dyn regio(‘s)","buttonText":"Besjoch abonneminten"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/fy/region-select.json
// module id = gS8G
// module chunks = 1